import apiFetch from '../apiFetch'
export default function (token, metadatoId) {
  return apiFetch({ endPoint: `metadato/DependanceMetadato?metadatoId=${metadatoId}`, method: 'GET', body: null, token: token })
}
